export default {
	delete: {
		id: false,
		fetching: false,
		loaded: false,
		error: {
			status: false,
			message: '',
		}
	},
	collection: {
		items: [],
		total: 0,
		itemsPerPage: 20,
		page: 1,
		fetching: false,
		loaded: false,
		error: {
			status: false,
			message: '',
		}
	},
	item: {
		props: {},
		fetching: false,
		loaded: false,
		error: {
			status: false,
			message: '',
		}
	}
};
